<style lang="less">
@import "./login.less";
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="Vnlin - OMS" :bordered="false">
        <div class="form-con">
          <login-form v-if="!$store.state.user.waitValidateCode" @on-success-valid="handleSubmit"></login-form>
          <div v-else>
            <h4 style="margin-bottom: 15px;">IP地址变化需要使用邮箱验证码登录系统</h4>
            <Form ref="formInline" >
              <FormItem prop="user">
                <Input type="text" v-model="validateCode" placeholder="请输入邮箱验证码">
                  <Icon type="ios-person-outline" slot="prepend"></Icon>
                </Input>
              </FormItem>

              <FormItem>
                <Button type="primary" @click="validateStaffCode('formInline')">验证数据</Button>

                <Button type="warning" style="margin-left: 5px;" @click="reSend('formInline')" :disabled="waitReSend">重发验证码</Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from "_c/login-form";
import { mapActions } from "vuex";
import {reSendValidateCode, validateCode, validateCodeCallback} from "@/api/user/client";
export default {
  components: {
    LoginForm
  },
  data() {
    return {
      validateCode: '',
      waitReSend: false,
    }
  },
  methods: {
    validateStaffCode() {
      validateCodeCallback(this.validateCode).then(res => {
        if (res.data.code) {
          // 发生了错误
          this.$Message.error(res.data.msg)
        } else {
          // 验证成功
          this.$Message.success({
            content: '验证成功, 正在转向系统',
            onClose: () => {
              this.getUserInfo();
              this.$router.push({
                name: this.$config.homeName
              });
            }
          })
        }
      })
    },
    reSend() {
      this.waitReSend = true
      reSendValidateCode().then(res => {
        this.$Message.success('已经重新发送了验证码')
        this.waitReSend = false
      })
    },
    ...mapActions(["handleLogin", "getUserInfo"]),
    handleSubmit({ userName, password }) {
      this.handleLogin({ userName, password })
        .then(() => {
          this.$nextTick(() => {
            if (this.$store.state.user.waitValidateCode) {
              // 显示一个窗口

            } else {
              this.getUserInfo();
              this.$router.push({
                name: this.$config.homeName
              });
            }
          })
          // this.$router.push({
          //   name: this.$route.query.redirect
          //     ? this.$route.query.redirect
          //     : this.$config.homeName
          // });

        })
        .catch(err => {
          this.$Message["error"]({
            background: true,
            content: err
          });
        });
    }
  }
};
</script>

<style>
.ivu-card-head p i,
.ivu-card-head p span {
  font-size: 16px;
  color: red;
  font-weight: bold;
}
</style>
